module.exports = __webpack_public_path__ + "img/oneBlue.e7182581.jpg";